import { render } from "./FramePrintTemplateEditor.vue?vue&type=template&id=532a0063&scoped=true"
import script from "./FramePrintTemplateEditor.vue?vue&type=script&lang=js"
export * from "./FramePrintTemplateEditor.vue?vue&type=script&lang=js"

import "./FramePrintTemplateEditor.vue?vue&type=style&index=0&id=532a0063&lang=less&scoped=true"

import exportComponent from "E:\\work\\苏州卓盛\\捷博独立发货\\jb-dji-wms-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-532a0063"]])

export default __exports__